import script from "./add.vue?vue&type=script&setup=true&lang=js"
export * from "./add.vue?vue&type=script&setup=true&lang=js"

import "./add.vue?vue&type=style&index=0&id=4d1e45fc&lang=less&scoped=true"

import exportComponent from "/Volumes/Mac_SSD/work_desktop/old-im/webapp-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1e45fc"]])

export default __exports__